import { app } from '../../../bootstrap/core';
import AffixDirective from './affix.directive';

app.directive('affix', AffixDirective);
